import store from '@/uteis/store'

export const INVALID = false
export const VALID = true

const rulesDictionary = () => {
  const dictionary = {}

  for (const index in store.getters.getDadosSessao.permission.dictionary) {
    dictionary[index] = index
  }

  return {
    ...dictionary
  }
}
export const rules = rulesDictionary()

export const componentIsVisible = (component) => {
  if (!component) {
    return INVALID
  }

  var profiles = store.getters.getDadosSessao.sessao.papeis.split('|')
  var profilesPermission = store.getters.getDadosSessao.permission.dictionary[component]

  let isVisible = INVALID
  for (var index in profiles) {
    var profile = profiles[index].trim()
    if (isVisible === INVALID && profilesPermission[profile] !== undefined) {
      isVisible = profilesPermission[profile]
    }
  }

  const idUser = store.getters.getDadosSessao.sessao.login.split('@')[0].toString()
  if (profilesPermission[idUser] !== undefined) {
    isVisible = profilesPermission[idUser]
  }

  return isVisible
}
